export default __webpack_public_path__ + "media/images/images/elements/06-94950a34fd320f184e263f693450dc2b.png";